var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoAngoisse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "icon",
    transform: "translate(-864.000000, -854.000000)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.000000, 471.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7090909,0 C7.03313455,0 0,7.03313455 0,15.7090909 C0,24.3850473 7.03313455,31.4181818 15.7090909,31.4181818 C24.3850473,31.4181818 31.4181818,24.3850473 31.4181818,15.7090909 C31.4181818,7.03313455 24.3850473,0 15.7090909,0 Z M15.7090909,29.3236364 C8.20189091,29.3236364 2.09454545,23.2162909 2.09454545,15.7090909 C2.09454545,8.20189091 8.20189091,2.09454545 15.7090909,2.09454545 C23.2162909,2.09454545 29.3236364,8.20189091 29.3236364,15.7090909 C29.3236364,23.2162909 23.2162909,29.3236364 15.7090909,29.3236364 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7090909,20.2472727 C9.77454545,20.2472727 9.77454545,24.7854545 9.77454545,24.7854545 L21.6436364,24.7854545 C21.6436364,24.7854545 21.6436364,20.2472727 15.7090909,20.2472727 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.90181818,
    cy: 13.0909091,
    r: 2.96727273
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.5163636,
    cy: 13.0909091,
    r: 2.96727273
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAngoisse);
export default __webpack_public_path__ + "static/media/picto-angoisse.3f3ffd5ecbabf498fc440a16614bc586.svg";
export { ForwardRef as ReactComponent };